import { ExtraPermission } from '@piccolohealth/pbs-common';
import { Spin } from '@piccolohealth/ui';
import React from 'react';
import { PageError } from '../../../components/generic/PageError';
import { useAppContext } from '../../../hooks/useAppContext';

// TODO: Remove this component when redo permissions
export const AdminProtectedRoute = (props: React.PropsWithChildren) => {
  const { children } = props;
  const { auth, user } = useAppContext();

  const hasPermission = user.extraPermissions.includes(ExtraPermission.Support);

  if (auth.isLoading || user.isLoading) {
    return <Spin />;
  }

  if (!auth.isAuthenticated) {
    return <Spin />;
  }

  if (!hasPermission) {
    return <PageError type='Forbidden' />;
  }

  return <>{children}</>;
};
